var N = (t) => {
  throw TypeError(t);
};
var f = (t, s, e) => s.has(t) || N("Cannot " + e);
var c = (t, s, e) => (f(t, s, "read from private field"), e ? e.call(t) : s.get(t)), l = (t, s, e) => s.has(t) ? N("Cannot add the same private member more than once") : s instanceof WeakSet ? s.add(t) : s.set(t, e), m = (t, s, e, i) => (f(t, s, "write to private field"), i ? i.call(t, e) : s.set(t, e), e), E = (t, s, e) => (f(t, s, "access private method"), e);
import { e as v, i as g, t as M } from "./directive-C5OgdAy2.js";
const O = {
  skipPreRender: !1
};
var r, a, d, u;
const h = class h extends g {
  constructor(e) {
    super(e);
    l(this, r);
    l(this, a);
    const { type: i, element: o, options: n } = e;
    if (i !== M.ELEMENT || !(o instanceof HTMLSlotElement))
      throw new Error(
        "The `whiteSpaceSensitive` directive must be used on a `<slot>` element."
      );
    if (m(this, r, o), c(this, r).name)
      throw new Error(
        "The `whiteSpaceSensitive` directive should only go on default slots."
      );
    n != null && n.host && m(this, a, n.host);
  }
  render(e) {
    var n;
    const i = Object.assign({ ...O }, e), { skipPreRender: o } = i;
    o || E(n = h, d, u).call(n, c(this, a).childNodes), c(this, r).addEventListener("slotchange", (x) => {
      var w;
      const T = c(this, r).assignedNodes();
      E(w = h, d, u).call(w, T);
    });
  }
};
r = new WeakMap(), a = new WeakMap(), d = new WeakSet(), u = function(e) {
  e.forEach((i) => {
    var o;
    i.nodeType !== Node.COMMENT_NODE && (i instanceof HTMLElement && i.slot || !((o = i.textContent) != null && o.trim()) && i instanceof Text && i.remove());
  });
}, l(h, d);
let p = h;
const b = v(p);
export {
  b as w
};
